import { render, staticRenderFns } from "./AddEmployeeToRoutes.vue?vue&type=template&id=5edac6df&"
import script from "./AddEmployeeToRoutes.vue?vue&type=script&lang=js&"
export * from "./AddEmployeeToRoutes.vue?vue&type=script&lang=js&"
import style0 from "./AddEmployeeToRoutes.vue?vue&type=style&index=0&id=5edac6df&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports